__webpack_require__.p = "/acnh-collections-tracker/";